import { SHOW_SNACKBAR } from './actions'

export const snackbarOptions = (state = null, action) => {
  switch (action.type) {
    case SHOW_SNACKBAR:
      return action.snackbarOptions
    default:
      return state
  }
}
